import { C as Component } from "./utilities-Da0sjanJ.js";
class QuickViewToggle extends Component {
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  /**
   * Open the quick view dialog for a specific product.
   * @param {{ targetDialog: string, productHandle: string }} data
   * @param {Event} event
   */
  showQuickView(data, event) {
    event.preventDefault();
    event.stopPropagation();
    const dialog = document.querySelector(data.targetDialog);
    if (!dialog) {
      return;
    }
    if (typeof dialog.showDialogForProduct === "function") {
      dialog.showDialogForProduct(data.productHandle);
    }
  }
}
if (!customElements.get("quick-view-toggle")) {
  customElements.define("quick-view-toggle", QuickViewToggle);
}
